export default __webpack_public_path__ + "static/media/banner7en.e5515a2b.png";